import script from "./purchases.vue?vue&type=script&setup=true&lang=js"
export * from "./purchases.vue?vue&type=script&setup=true&lang=js"

import "./purchases.vue?vue&type=style&index=0&id=63aee218&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63aee218"]])

export default __exports__